import { PMS_BACKEND_URL, PMS_ID } from "../config";

export async function fetchReservationGuests({ hotelID, reservationId }) {
    const res = await fetch(`${PMS_BACKEND_URL}${PMS_ID}/${hotelID}/${reservationId}`);
    if (!res.ok) throw new Error("Failed to fetch reservation guests");
    return await res.json();
  }

